import { AnyAction, Dispatch } from '@reduxjs/toolkit';

import { TSelectOption } from '@interfaces/components/componentTypes';

interface ISetFilterUtilInterface {
	selectedValue: TSelectOption;
	currentValue: any;
	setAction: (value: any) => AnyAction;
	fieldName: string;
	dispatch: Dispatch<any>;
}

interface ISetMultiSelectFilterUtilInterface {
	selectedValues: TSelectOption[] | null;
	setAction: (value: any) => AnyAction;
	fieldName: string;
	dispatch: Dispatch<any>;
}

export const setFilterUtil = ({
	selectedValue,
	currentValue,
	setAction,
	fieldName,
	dispatch,
}: ISetFilterUtilInterface) => {
	if (!selectedValue && currentValue !== selectedValue) {
		dispatch(setAction({ [fieldName]: selectedValue }));
	} else if (selectedValue && currentValue !== selectedValue.value) {
		dispatch(setAction({ [fieldName]: selectedValue.value }));
	}
};

export const setMultiSelectFilterUtil = ({
	selectedValues,
	setAction,
	fieldName,
	dispatch,
}: ISetMultiSelectFilterUtilInterface) => {
	if (!selectedValues) {
		dispatch(setAction({ [fieldName]: selectedValues }));
	} else {
		const values = selectedValues.map(selectedValue => selectedValue?.value);

		dispatch(setAction({ [fieldName]: values }));
	}
};
